import { render } from "./ButtonModuleCorrection.vue?vue&type=template&id=756de0c1"
import script from "./ButtonModuleCorrection.vue?vue&type=script&lang=js"
export * from "./ButtonModuleCorrection.vue?vue&type=script&lang=js"
script.render = render

export default script